<template>
  <div class="clean-green grid-container">
    <h2 class="header">
      {{ $t("clean-green.clean-green") }}
    </h2>
    <div class="content mvl">
      {{ $t("clean-green.clean-green-statement") }}
    </div>
    <div
      ref="numbersSection"
      class="numbers-grid pvl"
    >
      <div class="grid-x">
        <div class="cell small-12 medium-6 pbxl">
          <div class="icon">
            <i class="fa-solid fa-broom-wide" />
          </div>
          <div class="content">
            <div
              ref="blocksSwept"
              class="number mtl"
            >
              {{ formattedNumber(tweeningBlocksSwept) }}
            </div>
            <div class="description">
              {{ $t("clean-green.blocks-swept") }}
            </div>
          </div>
        </div>
        <div class="cell small-12 medium-6 pbxl">
          <div class="icon">
            <i class="fa-solid fa-cars" />
          </div>
          <div class="content">
            <div
              ref="abandonedAutos"
              class="number mtl"
            >
              {{ formattedNumber(tweeningAbandonedAutos) }}
            </div>
            <div class="description">
              {{ $t("clean-green.abandoned-autos") }}
            </div>
          </div>
        </div>
        <div class="cell small-12 medium-6 pbxl">
          <div class="icon">
            <i class="fa-solid fa-house-building" />
          </div>
          <div class="content">
            <div
              ref="propsCleanSeal"
              class="number mtl"
            >
              {{ formattedNumber(tweeningPropsCleanSeal) }}
            </div>
            <div class="description">
              {{ $t("clean-green.properties-cleaned") }}
            </div>
          </div>
        </div>
        <div class="cell small-12 medium-6 pbxl">
          <div class="icon">
            <i class="fa-solid fa-spray-can" />
          </div>
          <div class="content">
            <div
              ref="grafRemoved"
              class="number mtl"
            >
              {{ formattedNumber(tweeningGrafRemoved) }}
            </div>
            <div class="description">
              {{ $t("clean-green.graffiti-removed") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-container group">
      <a
        class="button content-type-featured"
        href="https://www.phila.gov/departments/office-of-clean-and-green-initiatives/"
        aria-label="Learn more"
      >
        {{ $t("clean-green.see-all-clean-green") }}
        <i
          class="fas fa-angle-right fa-lg"
          aria-hidden="true"
        />
      </a>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      apiURL: process.env.VUE_APP_CLEAN_GREEN_API_URL,
      grafRemoved: 0,
      propsCleanSeal: 0,
      abandonedAutos: 0,
      blocksSwept: 0,
      tweeningBlocksSwept: 0,
      tweeningAbandonedAutos: 0,
      tweeningPropsCleanSeal: 0,
      tweeningGrafRemoved: 0,
      observer: null,
    };
  },
  computed: {
    tweenedBlocksSwept() {
      return this.tweeningBlocksSwept;
    },
    tweenedAbandonedAutos() {
      return this.tweeningAbandonedAutos;
    },
    tweenedPropsCleanSeal() {
      return this.tweeningPropsCleanSeal;
    },
    tweenedGrafRemoved() {
      return this.tweeningGrafRemoved;
    },
  },
  mounted() {
    this.createObserver();
    this.getData();
  },
  methods: {
    createObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.startTweens();
            this.observer.disconnect(); // Stop observing after the first trigger
          }
        });
      });
      this.observer.observe(this.$refs.numbersSection);
    },
    startTweens() {
      this.tween(0, this.blocksSwept, 'blocksSwept');
      this.tween(0, this.abandonedAutos, 'abandonedAutos');
      this.tween(0, this.propsCleanSeal, 'propsCleanSeal');
      this.tween(0, this.grafRemoved, 'grafRemoved');
    },
    async getData() {
      try {
        const response = await axios.get(this.apiURL);
        const data = response.data;
        this.blocksSwept = data.features.reduce((total, feature) => {
          return total + feature.attributes.sanit;
        }, 0);
        this.abandonedAutos = data.features.reduce((total, feature) => {
          return total + feature.attributes.auto + feature.attributes.auto_ppa;
        }, 0);
        this.propsCleanSeal = data.features.reduce((total, feature) => {
          return total + feature.attributes.cleanseal;
        }, 0);
        this.grafRemoved = data.features.reduce((total, feature) => {
          return total + feature.attributes.graf;
        }, 0);
      } catch (error) {
        console.error(error);
      }
    },
    formattedNumber(num) {
      if (num > 999) {
        return (num / 1000).toFixed(1) + "k";
      }
      return num.toString();
    },
    tween(startValue, endValue, property) {
      var vm = this;
      let start = { value: startValue };
      let end = { value: endValue };

      function animate() {
        if (start.value < end.value) {
          start.value += (end.value - start.value) / 50;
          vm['tweening' + property.charAt(0).toUpperCase() + property.slice(1)] = Math.ceil(start.value);
          requestAnimationFrame(animate);
        }
      }

      animate();
    },
  },
};
</script>
